import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import React, { useMemo, useState, useEffect } from "react";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import { useTranslation } from "@i18n";
import { useParams } from "react-router-dom";
import { BottomSheet } from "@componentsShared/BottomSheet";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import useBoolean from "@hooks/useBoolean";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import { trackEvents } from "@/common/events/events";
import FinanceDetailsCard from "@/components/shared/FinanceDetailsCard/FinanceDetailsCard";
import { getFinanceCalculatorCarCondition } from "@/_MiniApps/Installment-calculator/carHelpers";
import { calculateFinanceValues } from "@/_MiniApps/Installment-calculator/calculateFinanceValues";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import useIsMobile from "@hooks/useIsMobile";
import { api__getWarrantyList } from "@/apis/orders/orders";
var FinanceDetailsBox = function FinanceDetailsBox(_ref) {
  var _postData$g4Data2, _localWarrantyData$fi, _postData$g4Data3, _localWarrantyData$fi2;
  var checkoutOrder = _ref.checkoutOrder,
    setCheckoutOrder = _ref.setCheckoutOrder,
    selectedWarrantyId = _ref.selectedWarrantyId,
    showEditIcon = _ref.showEditIcon;
  var postData = useAribFinance().state.postData;
  var post_id = useAribFinance().queryParams.post_id;
  var _useTranslation = useTranslation(["web_checkout_finance", "web_post_view"]),
    t = _useTranslation.t;
  var params = useParams();
  var calculator = useBoolean();
  var installmentCalculatorData = useAribFinance().state.installmentCalculatorData;
  var helper__getFinanceCalculatorData = useAribFinance().helpers.helper__getFinanceCalculatorData;
  var action__handleCalculatorDataChange = useAribFinance().actions.action__handleCalculatorDataChange;
  var _useState = useState(false),
    hasInteracted = _useState[0],
    setHasInteracted = _useState[1];
  var isMobile = useIsMobile();
  // Pending warranty data from period changes inside calculator — NOT pushed to parent until submit
  var _useState2 = useState(null),
    localWarrantyData = _useState2[0],
    setLocalWarrantyData = _useState2[1];

  // Internal handler: calls API on period change but stores locally — parent checkoutOrder is NOT updated
  var handleInternalPeriodChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(period) {
      var _checkoutOrder$financ, _checkoutOrder$financ2, _checkoutOrder$financ3;
      var currentWarrantyId, apiParams, updated;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            currentWarrantyId = selectedWarrantyId !== null && selectedWarrantyId !== void 0 ? selectedWarrantyId : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ === void 0 ? void 0 : (_checkoutOrder$financ2 = _checkoutOrder$financ.items) === null || _checkoutOrder$financ2 === void 0 ? void 0 : (_checkoutOrder$financ3 = _checkoutOrder$financ2.find(function (i) {
              return i.selected;
            })) === null || _checkoutOrder$financ3 === void 0 ? void 0 : _checkoutOrder$financ3.id;
            apiParams = {
              post_id: Number(post_id),
              installment_period: period
            };
            if (currentWarrantyId) {
              apiParams.warranty_id = currentWarrantyId;
            }
            _context.n = 1;
            return api__getWarrantyList(apiParams)["catch"](function () {
              return null;
            });
          case 1:
            updated = _context.v;
            if (updated) setLocalWarrantyData(updated);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleInternalPeriodChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Wraps the Arib context handler to also push pending warranty data to parent on submit
  var handleCalculatorDataChangeWithSync = function handleCalculatorDataChangeWithSync(calculatorData) {
    action__handleCalculatorDataChange(calculatorData);
    if (localWarrantyData) {
      setCheckoutOrder(function (prev) {
        return prev ? _objectSpread(_objectSpread({}, prev), localWarrantyData) : localWarrantyData;
      });
    }
  };
  var handleFirstInteraction = function handleFirstInteraction(_ref3) {
    var field = _ref3.field;
    if (hasInteracted) {
      console.log('field', field);
      setHasInteracted(false);
      trackEvents("finance_calculator_interact", {
        post_id: post_id,
        field_interaction: field
      });
    }
  };
  useEffect(function () {
    if (calculator.value) {
      setHasInteracted(true);
    } else {
      setHasInteracted(false);
      // Reset pending warranty data when calculator is dismissed without submitting
      setLocalWarrantyData(null);
    }
  }, [calculator.value]);
  var handleCalculatorClick = function handleCalculatorClick() {
    calculator.setTrue();
    trackEvents("finance_calculator_open", {
      post_id: post_id
    });
  };

  // Recalculate finance values when checkoutOrder.finance_calculator_data changes (e.g. warranty selected)
  var recalculated = useMemo(function () {
    var _postData$g4Data, _installmentCalculato, _installmentCalculato2;
    var cashPrice = postData === null || postData === void 0 ? void 0 : (_postData$g4Data = postData.g4Data) === null || _postData$g4Data === void 0 ? void 0 : _postData$g4Data.post_price;
    if (!cashPrice) return null;
    var carCondition = getFinanceCalculatorCarCondition(postData);
    var isPreowned = postData === null || postData === void 0 ? void 0 : postData.is_preowned;
    return calculateFinanceValues(carCondition, cashPrice, isPreowned, installmentCalculatorData ? {
      period: installmentCalculatorData.period,
      down_payment: installmentCalculatorData.down_payment,
      last_payment: installmentCalculatorData.last_payment,
      max_down_payment_percent: (_installmentCalculato = installmentCalculatorData.max_down_payment_percent) !== null && _installmentCalculato !== void 0 ? _installmentCalculato : 0.5,
      max_last_payment_percent: (_installmentCalculato2 = installmentCalculatorData.max_last_payment_percent) !== null && _installmentCalculato2 !== void 0 ? _installmentCalculato2 : 0.45
    } : null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data);
  }, [postData, installmentCalculatorData, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data]);
  var fallbackData = helper__getFinanceCalculatorData();
  var financeData = recalculated ? {
    installmentPeriod: recalculated.period || 0,
    down_payment: recalculated.down_payment || 0,
    last_payment: recalculated.last_payment || 0,
    monthly_installment: recalculated.monthly_installment || 0
  } : fallbackData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [" overflow-hidden", !helper__getFinanceCalculatorData ? "blur-[1px]" : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(FinanceDetailsCard, {
    title: (postData === null || postData === void 0 ? void 0 : postData.title) || '',
    installmentPeriod: financeData === null || financeData === void 0 ? void 0 : financeData.installmentPeriod,
    down_payment: financeData === null || financeData === void 0 ? void 0 : financeData.down_payment,
    last_payment: financeData === null || financeData === void 0 ? void 0 : financeData.last_payment,
    monthly_installment: financeData === null || financeData === void 0 ? void 0 : financeData.monthly_installment,
    showEditIcon: showEditIcon,
    onEditClick: handleCalculatorClick
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-center text-xs font-medium leading-4 mt-2"
  }, t("numbers_approximate_adjust_later", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(Conditional, {
    condition: !isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(BottomSheet, {
    open: calculator.value,
    onOpen: calculator.setTrue,
    onClose: calculator.setFalse,
    maxHeight: "95%",
    maxHeightDesktop: "95%",
    hideTitleBar: true,
    screens: [{
      title: t('calculate_financing_2', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
        carCondition: getFinanceCalculatorCarCondition(postData),
        cashPrice: (postData === null || postData === void 0 ? void 0 : (_postData$g4Data2 = postData.g4Data) === null || _postData$g4Data2 === void 0 ? void 0 : _postData$g4Data2.post_price) || 100000,
        onClose: calculator.setFalse,
        onInteraction: handleFirstInteraction,
        isPreowned: postData === null || postData === void 0 ? void 0 : postData.is_preowned,
        postId: post_id,
        onDataChange: handleCalculatorDataChangeWithSync,
        dynamicFinanceCalculatorData: (_localWarrantyData$fi = localWarrantyData === null || localWarrantyData === void 0 ? void 0 : localWarrantyData.finance_calculator_data) !== null && _localWarrantyData$fi !== void 0 ? _localWarrantyData$fi : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data,
        onPeriodChange: handleInternalPeriodChange,
        isEligibleForArib: postData === null || postData === void 0 ? void 0 : postData.is_eligible_for_arib
      })
    }, {
      title: t('financing_conditions', {
        ns: "web_post_view"
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)
    }]
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: calculator.value,
    onOpenChange: calculator.toggle,
    repositionInputs: false,
    preventScrollRestoration: true
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "max-h-[110vh] z-[9999999]"
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    className: "bg-white p-0 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 py-4"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: "p-0 rounded-full bg-transparent outline-none border-none w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    className: "text-gray-text",
    height: 6,
    width: 6
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text font-bold w-full text-center"
  }, t('calculate_financing_2', {
    ns: 'web_post_view'
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1 max-h-fit bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right space-y-4 text-[#333333]"
  }, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '20px',
        textAlign: 'center'
      }
    }, "Loading Calculator...")
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
    carCondition: getFinanceCalculatorCarCondition(postData),
    cashPrice: (postData === null || postData === void 0 ? void 0 : (_postData$g4Data3 = postData.g4Data) === null || _postData$g4Data3 === void 0 ? void 0 : _postData$g4Data3.post_price) || 100000,
    onClose: calculator.setFalse,
    onInteraction: handleFirstInteraction,
    onDataChange: handleCalculatorDataChangeWithSync,
    postId: post_id,
    initialValues: installmentCalculatorData,
    isPreowned: postData === null || postData === void 0 ? void 0 : postData.is_preowned,
    dynamicFinanceCalculatorData: (_localWarrantyData$fi2 = localWarrantyData === null || localWarrantyData === void 0 ? void 0 : localWarrantyData.finance_calculator_data) !== null && _localWarrantyData$fi2 !== void 0 ? _localWarrantyData$fi2 : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data,
    onPeriodChange: handleInternalPeriodChange,
    isEligibleForArib: postData === null || postData === void 0 ? void 0 : postData.is_eligible_for_arib
  })))))))))));
};
export default FinanceDetailsBox;